import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VBtn,
    _vm._b({ on: { click: _vm.downloadExcel } }, "v-btn", _vm.$attrs, false),
    [
      _c(VIcon, { staticClass: "mr-2" }, [_vm._v("mdi-microsoft-excel")]),
      _vm._v(" Download "),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }